import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.add-active-directory', {
        url: '/add-active-directory',
        views: {
            '@company.directory-integration': 'companyDirectoryIntegrationAddActiveDirectory'
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/add/add-active-directory.state.js